<ng-template #usageLimitsModalForm let-modal>

  <app-modal-comp-header
    [title]="formTitle"
    (cancelButtonOnClick)="usageLimitsFormCancel()"
  ></app-modal-comp-header>

  <form (ngSubmit)="usageLimitsFormSubmit()" [formGroup]="usageLimitsForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">

      <!-- Limit Type Cards -->
      <p class="fw-semibold mb-2">Limit Type</p>
      <div class="row g-3 mb-3 justify-content-center">
        @if (showNoLimit) {
          <div class="col-4">
            <div class="limit-type-card" [class.selected]="selectedLimitType === LimitType.Off" (click)="selectLimitType(LimitType.Off)">
              <span class="limit-card-icon"><i class="bi-infinity"></i></span>
              <div class="limit-card-title">No Limit</div>
              <div class="limit-card-subtitle">Unrestricted usage</div>
            </div>
          </div>
        }
        <div class="col-4">
          <div class="limit-type-card" [class.selected]="selectedLimitType === LimitType.Spend" (click)="selectLimitType(LimitType.Spend)">
            <span class="limit-card-icon" [class.text-success]="selectedLimitType === LimitType.Spend"><i class="bi-cash-stack"></i></span>
            <div class="limit-card-title" [class.text-success]="selectedLimitType === LimitType.Spend">Spend Limit</div>
            <div class="limit-card-subtitle">Restrict by cost</div>
          </div>
        </div>
        @if (showDataLimit) {
          <div class="col-4">
            <div class="limit-type-card" [class.selected]="selectedLimitType === LimitType.Data" (click)="selectLimitType(LimitType.Data)">
              <span class="limit-card-icon" [class.text-success]="selectedLimitType === LimitType.Data"><i class="bi-bar-chart-fill"></i></span>
              <div class="limit-card-title" [class.text-success]="selectedLimitType === LimitType.Data">Data Usage Limit</div>
              <div class="limit-card-subtitle">Restrict by volume</div>
            </div>
          </div>
        }
      </div>

      <!-- Spend Limit Configuration -->
      @if (selectedLimitType === LimitType.Spend) {
        <div class="limit-config-area">

          <div class="limit-info-box mb-3">
            <i class="bi-info-circle-fill me-2"></i>
            @if (companyUsageLimit) {
              The <strong class="text-success">Company Level</strong> limit ({{companyCurrencySymbol}}{{companyUsageLimit}}) is the default. Toggle below to set a custom limit for this SIM.
            } @else {
              There is no Company Level spend limit set. Toggle below to set a custom limit for this SIM.
            }
          </div>

          <!-- Spend Limit Configuration section -->
          <div class="limit-config-section mb-3">
            <div class="d-flex align-items-center mb-2">
              <span class="fw-semibold">
                {{textSpendLimit}} Configuration
                <i *ngIf="!showHintSpendLimit"
                  [attr.title]="hintSpendLimit"
                  class="bi bi-question-circle text-secondary ms-1"
                  style="cursor: pointer;">
                </i>
              </span>
            </div>
            <div *ngIf="showHintSpendLimit" class="text-muted small mb-2 px-1">{{hintSpendLimit}}</div>
            <div class="limit-config-row">
              <div>
                <div class="fw-medium small">Use Custom Limit</div>
                @if (companyUsageLimit) {
                  <div class="text-muted" style="font-size: 0.78rem;">Override company default ({{companyCurrencySymbol}}{{companyUsageLimit}})</div>
                } @else {
                  <div class="text-muted" style="font-size: 0.78rem;">Set spend limit ({{companyCurrencySymbol}})</div>
                }
              </div>
              <div class="form-check form-switch mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="useCustomSpendLimit-field"
                  [checked]="useCustomSpendLimit"
                  style="transform: scale(1.3);"
                  (change)="onUseCustomSpendLimitChange($event)"
                />
              </div>
            </div>
            @if (useCustomSpendLimit) {
              <div class="mt-2 px-1">
                <div class="input-group" [class.is-invalid]="formSubmitted && formOfUsageLimits['usageLimit'].errors">
                  <span class="input-group-text">{{companyCurrencySymbol}}</span>
                  <input
                    autocomplete="no-fill"
                    class="form-control"
                    formControlName="usageLimit"
                    id="usageLimit-field"
                    [ngClass]="{ 'is-invalid': formSubmitted && formOfUsageLimits['usageLimit'].errors }"
                    placeholder="Enter spend limit"
                    type="number"
                  />
                </div>
                <div class="invalid-feedback">A value is required</div>
              </div>
            }
          </div>

          <!-- Self Auth Spend Limit section -->
          @if (showSelfAuthSpendLimit) {
            <div class="limit-config-section mb-3">
              <div class="d-flex align-items-center mb-2">
                <span class="fw-semibold">
                  {{textSelfAuthSpendLimit}}
                  <i *ngIf="!showHintSelfAuthSpendLimit"
                    [attr.title]="hintSelfAuthSpendLimit"
                    class="bi bi-question-circle text-secondary ms-1"
                    style="cursor: pointer;">
                  </i>
                </span>
              </div>
              <div *ngIf="showHintSelfAuthSpendLimit" class="text-muted small mb-2 px-1">{{hintSelfAuthSpendLimit}}</div>
              <div class="limit-config-row mb-2">
                <div>
                  <div class="fw-medium small">Self Auth Limit</div>
                  <div class="text-muted" style="font-size: 0.78rem;">Company default: {{companySelfAuthLimit}}</div>
                </div>
              </div>
              <div class="px-1">
                <input
                  autocomplete="no-fill"
                  class="form-control"
                  formControlName="selfAuthLimit"
                  id="selfAuthLimit-field"
                  [ngClass]="{ 'is-invalid': formSubmitted && formOfUsageLimits['selfAuthLimit'].errors }"
                  placeholder=""
                  type="number"
                />
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          }

          <!-- Current Month Override section -->
          <div class="limit-config-section">
            <div class="d-flex align-items-center mb-2">
              <span class="fw-semibold">
                Current Month Override
                <i *ngIf="!showHintCurrentSpendLimit"
                  [attr.title]="hintCurrentSpendLimit"
                  class="bi bi-question-circle text-secondary ms-1"
                  style="cursor: pointer;">
                </i>
              </span>
            </div>
            <div *ngIf="showHintCurrentSpendLimit" class="text-muted small mb-2 px-1">{{hintCurrentSpendLimit}}</div>
            <div class="limit-config-row">
              <div>
                <div class="fw-medium small">Override This Month</div>
                <div class="text-muted" style="font-size: 0.78rem;">Set temporary limit for current month ({{companyCurrencySymbol}})</div>
              </div>
              <div class="form-check form-switch mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="overrideCurrentMonth-field"
                  [checked]="overrideCurrentMonth"
                  style="transform: scale(1.3);"
                  (change)="onOverrideCurrentMonthChange($event)"
                />
              </div>
            </div>
            @if (overrideCurrentMonth) {
              <div class="mt-2 px-1">
                <div class="input-group" [class.is-invalid]="formSubmitted && formOfUsageLimits['currentLimit'].errors">
                  <span class="input-group-text">{{companyCurrencySymbol}}</span>
                  <input
                    autocomplete="no-fill"
                    class="form-control"
                    formControlName="currentLimit"
                    id="currentLimit-field"
                    [ngClass]="{ 'is-invalid': formSubmitted && formOfUsageLimits['currentLimit'].errors }"
                    placeholder="Enter current month limit"
                    type="number"
                    (keyup)="currentLimitKeyUp($event)"
                  />
                </div>
                <div class="invalid-feedback">A value is required</div>
              </div>
            }
          </div>

        </div>
      }

      <!-- Data Usage Limit Configuration -->
      @if (selectedLimitType === LimitType.Data) {
        <div class="limit-config-area">

          <div class="limit-info-box mb-3">
            <i class="bi-info-circle-fill me-2"></i>
            @if (companyDataLimit) {
              The <strong class="text-success">Company Level</strong> data limit ({{companyDataLimit}} {{companyDataWeightCode}}) is the default. Toggle below to set a custom limit for this SIM.
            } @else {
              There is no Company Level data limit set. Toggle below to set a custom limit for this SIM.
            }
          </div>

          <!-- Data Limit Configuration section -->
          <div class="limit-config-section mb-3">
            <div class="d-flex align-items-center mb-2">
              <span class="fw-semibold">Data Limit Configuration</span>
            </div>
            <div class="limit-config-row">
              <div>
                <div class="fw-medium small">Use Custom Limit</div>
                @if (companyDataLimit) {
                  <div class="text-muted" style="font-size: 0.78rem;">Override company default ({{companyDataLimit}} {{companyDataWeightCode}})</div>
                } @else {
                  <div class="text-muted" style="font-size: 0.78rem;">Set data usage limit (MB)</div>
                }
              </div>
              <div class="form-check form-switch mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="useCustomDataLimit-field"
                  [checked]="useCustomDataLimit"
                  style="transform: scale(1.3);"
                  (change)="onUseCustomDataLimitChange($event)"
                />
              </div>
            </div>
            @if (useCustomDataLimit) {
              <div class="mt-2 px-1">
                <div class="d-flex align-items-stretch gap-2">
                  <input
                    autocomplete="no-fill"
                    class="form-control flex-grow-1"
                    formControlName="dataLimit"
                    id="dataLimit-field"
                    [ngClass]="{ 'is-invalid': formSubmitted && formOfUsageLimits['dataLimit'].errors }"
                    placeholder="Enter data limit"
                    type="number"
                  />
                  <div class="segmented-toggle" role="group" aria-label="Data limit unit">
                    <input
                      class="segmented-toggle-input"
                      formControlName="dataLimitUnit"
                      id="dataLimitUnit-mb"
                      type="radio"
                      value="MB"
                    />
                    <label class="segmented-toggle-option" for="dataLimitUnit-mb">MB</label>

                    <input
                      class="segmented-toggle-input"
                      formControlName="dataLimitUnit"
                      id="dataLimitUnit-gb"
                      type="radio"
                      value="GB"
                    />
                    <label class="segmented-toggle-option" for="dataLimitUnit-gb">GB</label>
                  </div>
                </div>
                <div class="invalid-feedback">A value is required</div>
              </div>
            }
          </div>

          <!-- Current Month Override section -->
          <div class="limit-config-section">
            <div class="d-flex align-items-center mb-2">
              <span class="fw-semibold">Current Month Override</span>
            </div>
            <div class="limit-config-row">
              <div>
                <div class="fw-medium small">Override This Month</div>
                <div class="text-muted" style="font-size: 0.78rem;">Set temporary data limit for current month ({{companyDataWeightCode}})</div>
              </div>
              <div class="form-check form-switch mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="overrideCurrentMonthData-field"
                  [checked]="overrideCurrentMonthData"
                  style="transform: scale(1.3);"
                  (change)="onOverrideCurrentMonthDataChange($event)"
                />
              </div>
            </div>
            @if (overrideCurrentMonthData) {
              <div class="mt-2 px-1">
                <div class="d-flex align-items-stretch gap-2">
                  <input
                    autocomplete="no-fill"
                    class="form-control flex-grow-1"
                    formControlName="dataLimitCurrent"
                    id="dataLimitCurrent-field"
                    [ngClass]="{ 'is-invalid': formSubmitted && formOfUsageLimits['dataLimitCurrent'].errors }"
                    placeholder="Enter current month data limit"
                    type="number"
                  />
                  <div class="segmented-toggle" role="group" aria-label="Current month data limit unit">
                    <input
                      class="segmented-toggle-input"
                      formControlName="dataLimitCurrentUnit"
                      id="dataLimitCurrentUnit-mb"
                      type="radio"
                      value="MB"
                    />
                    <label class="segmented-toggle-option" for="dataLimitCurrentUnit-mb">MB</label>

                    <input
                      class="segmented-toggle-input"
                      formControlName="dataLimitCurrentUnit"
                      id="dataLimitCurrentUnit-gb"
                      type="radio"
                      value="GB"
                    />
                    <label class="segmented-toggle-option" for="dataLimitCurrentUnit-gb">GB</label>
                  </div>
                </div>
                <div class="invalid-feedback">A value is required</div>
              </div>
            }
          </div>

        </div>
      }

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="usageLimitsFormCancel()">Close</button>
        <button type="submit" class="btn btn-success" id="add-btn">Submit</button>
      </div>
    </div>
  </form>
</ng-template>

<app-warning-modal-form #beforeCloseWarningModalForm
  [animationLink]="beforeCloseAnimationLink"
  (modalClosed)="beforeCloseWarningModalFormIsClosed()"
></app-warning-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
